import React from 'react'
import CurrencyTextField from '@unicef/material-ui-currency-textfield'
import FormHelperText from '@material-ui/core/FormHelperText'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  currencyTextFieldColor: {
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    },
    '& .MuiFormLabel-root.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.72)'
    }
  }
}))

export default function CurrencyField({
  input,
  label,
  currencySymbol = 'R$',
  decimal = ',',
  group = '.',
  meta,
  minimumValue = Number.MIN_SAFE_INTEGER.toString(),
  onChange,
  onBlur = () => {},
  valueCurrency,
  ...props
}) {
  const classes = useStyles()
  const handleChange = (event, value) => {
    onChange && onChange(event, value)
    input.onChange(value)
  }

  return (
    <div>
      <CurrencyTextField
        {...props}
        label={label}
        className={classes.currencyTextFieldColor}
        value={valueCurrency || input.value}
        currencySymbol={currencySymbol}
        error={meta.touched && !!meta.error}
        decimalCharacter={decimal}
        minimumValue={minimumValue}
        digitGroupSeparator={group}
        onChange={handleChange}
        onBlur={onBlur}
        textAlign="left"
      />
      <FormHelperText error hidden={!meta.touched}>
        {meta.error}
      </FormHelperText>
    </div>
  )
}
